Ext.define('ViewTramwajeMobile', {
    extend: 'Ext.panel.Panel',
    grid: null,
    windowObject: null,
    id: "tramwaje-view",
    taskContextMenu: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyName: "access.manage.tramwaje",
        accessPropertyViewName: "access.view.tramwaje"
    },
    cat: "p",
    text: Lang.tramwaje.capitalise(),
    buttonIconCls: "iconTramwaje",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.sterowanie_trybem_manual.capitalise(),
                scope: this,
                handler: this.sterowanieManual
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.start_manual_proces_tankowania.capitalise(),
                scope: this,
                handler: this.startManualTank
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.stop_manual_proces_tankowania.capitalise(),
                scope: this,
                handler: this.stopManualTank
            }
            ]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        if (this.grid && this.grid.rendered)
            this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    buildGrid: function () {
        var store = Ext.create('Ext.data.Store', {
            autoLoad: false,
            remoteSort: false,
            remoteFilter: false,
            pageSize: 50,
            fields: [{
                name: 'nazwa',
                mapping: 'nazwa'
            }, {
                name: 'wartosc',
                mapping: 'wartosc'
            }],
            proxy: {
                type: "ajax",
                url: "rest/tramwaje/getList",
                filterParam: "filters",
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data',
                    totalProperty: 'total',
                    id: 'id'
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            }
        });
        var cols = [{
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.wartosc,
            flex: 2,
            sortable: true,
            dataIndex: 'wartosc',
            filter: {
                type: 'string'
            },
            filterable: true
        }];
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            }
        });
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = grid.getStore().getAt(rowIndex);
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.grid.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    getDownloadLsPdf: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "pdf",
            name: Lang.awaryjne,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    return v;
                }
            }))
        }, null);
    },
    getDownloadLsExcel: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "excel",
            name: Lang.awaryjne,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    return v;
                }
            }))
        }, null);
    },
    refreshDatastore: function () {
        this.grid.store.load();
    },
    sterowanieManual: function () {
        windowObject = Ext.create('WindowSterowanieTramwajeManual', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW();
    },
    startManualTank: function () {
        windowObject = Ext.create('WindowStartManualTankTramwaje', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW();
    },
    stopManualTank: function () {
        windowObject = Ext.create('WindowStopManualTankTramwaje', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW();
    }
});
